/**
 * The three groups of the mentor step (R-05-01). The values are the backend's
 * own `preselectedOption` strings, so the screen can follow the list's answer
 * without translating it (R-05-10).
 */
export const ASSIGN_MODES = { KNOWN: "known", BEST: "bestMatched", SEARCH: "search" };

/* The group-1 tag the backend sets (R-05-02 to R-05-04). */
export const MENTOR_TAG_LABELS = {
  demo: "Demo mentor",
  current: "Current mentor",
  past: "Past mentor",
};
